import { render, staticRenderFns } from "./AlbumThumbnails.vue?vue&type=template&id=2abec22c&scoped=true"
import script from "./AlbumThumbnails.vue?vue&type=script&lang=js"
export * from "./AlbumThumbnails.vue?vue&type=script&lang=js"
import style0 from "./AlbumThumbnails.vue?vue&type=style&index=0&id=2abec22c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abec22c",
  null
  
)

export default component.exports